module.exports = __webpack_public_path__ + "img/box_pro_two_7.b90a3011.jpg";